<template>
  <div
    v-if="request"
    class="request-info-root"
  >
    <div v-if="request.code">
      <b><span class="label-highlighted">{{ local.bankruptcy.requestInfo.requestCode }}</span> {{ request.code }}</b>
    </div>
    <div v-if="request.creationDate">
      <b><span class="label-highlighted">{{ local.bankruptcy.requestInfo.requestDate }}</span> {{ toHijriDate( request.creationDate) }}</b>
    </div>
    <div v-if="request.requestStatusName">
      <b><span class="label-highlighted">{{ local.bankruptcy.requestInfo.status }}</span> {{ request.requestStatusName }}</b>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('BankruptcyModule');
import { toHijriDate } from '@/helpers/utils';

export default {
  data() {
    return { toHijriDate };
  },
  computed: { ...mapState({ request: state => state.mainRequest }) },
};
</script>

<style lang="scss">
.request-info-root {
  font-size: 13px;
  span {
    margin-right: 5px;
  }
}

    .label-highlighted {
        color: var(--app-primary-color);
    }
</style>
